import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { AccountingApi } from '_api';
import { handleError } from '_helpers/api';
import { getBankTransactions } from '_store/reports/slice';

export const addBankTransaction = createAsyncThunk(
  'currentTransaction/addBankTransaction',
  async function ({ customerId, productId, body }, { dispatch, rejectWithValue }) {
    try {
      await AccountingApi.addBankTransaction({ customerId, productId, body });
      toast.success('Transaction was added successfully!');
      dispatch(getBankTransactions({ customerId, productId }));
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

export const updateBankTransaction = createAsyncThunk(
  'currentTransaction/updateBankTransaction',
  async function ({ customerId, productId, transactionId, body }, { dispatch, rejectWithValue }) {
    try {
      await AccountingApi.updateBankTransaction({ customerId, productId, transactionId, body });
      toast.success('Transaction was updated successfully!');
      dispatch(getBankTransactions({ customerId, productId }));
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

export const deleteBankTransaction = createAsyncThunk(
  'currentTransaction/deleteBankTransaction',
  async function ({ customerId, productId, transactionId }, { dispatch, rejectWithValue }) {
    try {
      await AccountingApi.deleteBankTransaction({ customerId, productId, transactionId });
      toast.success('Transaction was deleted successfully!');
      dispatch(getBankTransactions({ customerId, productId }));
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const currentTransactionSlice = createSlice({
  name: 'currentTransaction',
  initialState: {
    result: false,
    error: null,
    loading: false,
  },
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBankTransaction.pending, (state) => {
        state.result = false;
        state.error = null;
        state.loading = true;
      })
      .addCase(addBankTransaction.fulfilled, (state) => {
        state.result = true;
        state.loading = false;
      })
      .addCase(addBankTransaction.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });

    builder
      .addCase(updateBankTransaction.pending, (state) => {
        state.result = false;
        state.error = null;
        state.loading = true;
      })
      .addCase(updateBankTransaction.fulfilled, (state) => {
        state.result = true;
        state.loading = false;
      })
      .addCase(updateBankTransaction.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });

    builder
      .addCase(deleteBankTransaction.pending, (state) => {
        state.result = false;
        state.error = null;
        state.loading = true;
      })
      .addCase(deleteBankTransaction.fulfilled, (state) => {
        state.result = true;
        state.loading = false;
      })
      .addCase(deleteBankTransaction.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetError } = currentTransactionSlice.actions;

export default currentTransactionSlice.reducer;
